import { useState, useEffect } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import { useI18n } from '@/contexts/I18nContext';
import { AuthForm } from '@/components/auth/AuthForm';
import { Header } from '@/components/layout/Header';
import { BottomNavigation } from '@/components/layout/BottomNavigation';
import { OnboardingCarousel } from '@/components/OnboardingCarousel';

const Index = () => {
  const [isSignUp, setIsSignUp] = useState(false);
  const [signUpStep, setSignUpStep] = useState(1);
  const [emailSentMessage, setEmailSentMessage] = useState<string | null>(null);
  const [hideOnboarding, setHideOnboarding] = useState(false);
  const { t } = useI18n();

  // Function to show the email sent message
  const handleEmailSent = (message: string) => {
    setEmailSentMessage(message);
    // Optionally, auto-hide after a few seconds
    // setTimeout(() => setEmailSentMessage(null), 8000);
  };

  return (
    <div className="min-h-screen pb-20 relative overflow-hidden bg-[#160C0C]">
      <Header />
      
      <div className="flex flex-col items-center justify-center min-h-[calc(100vh-140px)] px-4 py-8 relative z-10">
        <div className="w-full max-w-md relative overflow-x-hidden">
          {/* Onboarding Carousel */}
          {!hideOnboarding && !(isSignUp && signUpStep === 2) && <OnboardingCarousel />}
          {/* Email sent warning */}
          {emailSentMessage && (
            <div className="mb-4 px-4 py-3 pr-8 rounded border border-yellow-400 bg-yellow-100/80 text-yellow-900 text-center text-sm font-medium relative">
              <button
                type="button"
                onClick={() => setEmailSentMessage(null)}
                className="absolute top-2 right-2 text-yellow-900 hover:text-yellow-700 text-lg font-bold focus:outline-none"
                aria-label="Close"
              >
                ×
              </button>
              {emailSentMessage}
            </div>
          )}
          {/* Auth Toggle - Sign In first, then Sign Up */}
          <div className="flex mb-6">
            <button
              onClick={() => { setIsSignUp(false); setEmailSentMessage(null); setHideOnboarding(false); }}
              className={`flex-1 py-3 text-center font-medium transition-all duration-200 ${
                !isSignUp
                  ? 'text-white border-b-2 border-[#D72E16]'
                  : 'text-white/70 hover:text-white'
              }`}
            >
              {t('auth.sign_in')}
            </button>
            <button
              onClick={() => { setIsSignUp(true); setEmailSentMessage(null); }}
              className={`flex-1 py-3 text-center font-medium transition-all duration-200 ${
                isSignUp
                  ? 'text-white border-b-2 border-[#D72E16]'
                  : 'text-white/70 hover:text-white'
              }`}
            >
              {t('auth.sign_up')}
            </button>
          </div>

          {/* Auth Form */}
          <AuthForm
            isSignUp={isSignUp}
            setIsSignUp={setIsSignUp}
            onEmailSent={handleEmailSent}
            signUpStep={signUpStep}
            setSignUpStep={setSignUpStep}
            setHideOnboarding={setHideOnboarding}
          />
        </div>
      </div>

      <BottomNavigation isAuthenticated={false} />
    </div>
  );
};

export default Index;
